module.exports = __webpack_public_path__ + "img/im_scrollfeature_18.90aea6f5.jpg";